module.exports = __webpack_public_path__ + "static/sustainable_img1@2x-9cc5d86b4b13c592f1bc8ade0542e0b5.jpg";